import { defineComponent as ee, watchEffect as oe, ref as te, provide as ce, toRef as ne, computed as B, h } from "vue";
import { useRtl as le } from "./ghl-ui.es851.js";
import re from "./ghl-ui.es1000.js";
import se from "./ghl-ui.es1110.js";
import { warnOnce as ae } from "./ghl-ui.es853.js";
import ie from "./ghl-ui.es854.js";
import P from "./ghl-ui.es855.js";
import { createKey as n } from "./ghl-ui.es384.js";
import { getMargin as de } from "./ghl-ui.es856.js";
import { useThemeClass as he } from "./ghl-ui.es857.js";
import { color2Class as R } from "./ghl-ui.es885.js";
import { resolveWrappedSlot as y } from "./ghl-ui.es860.js";
import ge from "./ghl-ui.es859.js";
import { createInjectionKey as Ce } from "./ghl-ui.es896.js";
import fe from "./ghl-ui.es1111.js";
import { call as ue } from "./ghl-ui.es876.js";
const me = Object.assign(Object.assign(Object.assign({}, P.props), re), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  // private
  internalCloseFocusable: {
    type: Boolean,
    default: !0
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: !0
  },
  // deprecated
  onCheckedChange: Function
}), be = Ce("n-tag"), He = ee({
  name: "Tag",
  props: me,
  setup(t) {
    process.env.NODE_ENV !== "production" && oe(() => {
      t.onCheckedChange !== void 0 && ae("tag", "`on-checked-change` is deprecated, please use `on-update:checked` instead");
    });
    const a = te(null), {
      mergedBorderedRef: o,
      mergedClsPrefixRef: g,
      inlineThemeDisabled: C,
      mergedRtlRef: p
    } = ie(t), u = P("Tag", "-tag", se, fe, t, g);
    ce(be, {
      roundRef: ne(t, "round")
    });
    function f(e) {
      if (!t.disabled && t.checkable) {
        const {
          checked: c,
          onCheckedChange: d,
          onUpdateChecked: r,
          "onUpdate:checked": s
        } = t;
        r && r(!c), s && s(!c), d && d(!c);
      }
    }
    function m(e) {
      if (t.triggerClickOnClose || e.stopPropagation(), !t.disabled) {
        const {
          onClose: c
        } = t;
        c && ue(c, e);
      }
    }
    const b = {
      setTextContent(e) {
        const {
          value: c
        } = a;
        c && (c.textContent = e);
      }
    }, k = le("Tag", p, g), l = B(() => {
      const {
        type: e,
        size: c,
        color: {
          color: d,
          textColor: r
        } = {}
      } = t, {
        common: {
          cubicBezierEaseInOut: s
        },
        self: {
          padding: z,
          closeMargin: _,
          borderRadius: I,
          opacityDisabled: T,
          textColorCheckable: M,
          textColorHoverCheckable: O,
          textColorPressedCheckable: F,
          textColorChecked: H,
          colorCheckable: S,
          colorHoverCheckable: j,
          colorPressedCheckable: E,
          colorChecked: N,
          colorCheckedHover: U,
          colorCheckedPressed: D,
          closeBorderRadius: V,
          fontWeightStrong: w,
          [n("colorBordered", e)]: K,
          [n("closeSize", c)]: W,
          [n("closeIconSize", c)]: A,
          [n("fontSize", c)]: L,
          [n("height", c)]: x,
          [n("color", e)]: q,
          [n("textColor", e)]: G,
          [n("border", e)]: J,
          [n("closeIconColor", e)]: $,
          [n("closeIconColorHover", e)]: Q,
          [n("closeIconColorPressed", e)]: X,
          [n("closeColorHover", e)]: Y,
          [n("closeColorPressed", e)]: Z
        }
      } = u.value, v = de(_);
      return {
        "--n-font-weight-strong": w,
        "--n-avatar-size-override": `calc(${x} - 8px)`,
        "--n-bezier": s,
        "--n-border-radius": I,
        "--n-border": J,
        "--n-close-icon-size": A,
        "--n-close-color-pressed": Z,
        "--n-close-color-hover": Y,
        "--n-close-border-radius": V,
        "--n-close-icon-color": $,
        "--n-close-icon-color-hover": Q,
        "--n-close-icon-color-pressed": X,
        "--n-close-icon-color-disabled": $,
        "--n-close-margin-top": v.top,
        "--n-close-margin-right": v.right,
        "--n-close-margin-bottom": v.bottom,
        "--n-close-margin-left": v.left,
        "--n-close-size": W,
        "--n-color": d || (o.value ? K : q),
        "--n-color-checkable": S,
        "--n-color-checked": N,
        "--n-color-checked-hover": U,
        "--n-color-checked-pressed": D,
        "--n-color-hover-checkable": j,
        "--n-color-pressed-checkable": E,
        "--n-font-size": L,
        "--n-height": x,
        "--n-opacity-disabled": T,
        "--n-padding": z,
        "--n-text-color": r || G,
        "--n-text-color-checkable": M,
        "--n-text-color-checked": H,
        "--n-text-color-hover-checkable": O,
        "--n-text-color-pressed-checkable": F
      };
    }), i = C ? he("tag", B(() => {
      let e = "";
      const {
        type: c,
        size: d,
        color: {
          color: r,
          textColor: s
        } = {}
      } = t;
      return e += c[0], e += d[0], r && (e += `a${R(r)}`), s && (e += `b${R(s)}`), o.value && (e += "c"), e;
    }), l, t) : void 0;
    return Object.assign(Object.assign({}, b), {
      rtlEnabled: k,
      mergedClsPrefix: g,
      contentRef: a,
      mergedBordered: o,
      handleClick: f,
      handleCloseClick: m,
      cssVars: C ? void 0 : l,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    });
  },
  render() {
    var t, a;
    const {
      mergedClsPrefix: o,
      rtlEnabled: g,
      closable: C,
      color: {
        borderColor: p
      } = {},
      round: u,
      onRender: f,
      $slots: m
    } = this;
    f == null || f();
    const b = y(m.avatar, (l) => l && h("div", {
      class: `${o}-tag__avatar`
    }, l)), k = y(m.icon, (l) => l && h("div", {
      class: `${o}-tag__icon`
    }, l));
    return h("div", {
      class: [`${o}-tag`, this.themeClass, {
        [`${o}-tag--rtl`]: g,
        [`${o}-tag--strong`]: this.strong,
        [`${o}-tag--disabled`]: this.disabled,
        [`${o}-tag--checkable`]: this.checkable,
        [`${o}-tag--checked`]: this.checkable && this.checked,
        [`${o}-tag--round`]: u,
        [`${o}-tag--avatar`]: b,
        [`${o}-tag--icon`]: k,
        [`${o}-tag--closable`]: C
      }],
      style: this.cssVars,
      onClick: this.handleClick,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, k || b, h("span", {
      class: `${o}-tag__content`,
      ref: "contentRef"
    }, (a = (t = this.$slots).default) === null || a === void 0 ? void 0 : a.call(t)), !this.checkable && C ? h(ge, {
      clsPrefix: o,
      class: `${o}-tag__close`,
      disabled: this.disabled,
      onClick: this.handleCloseClick,
      focusable: this.internalCloseFocusable,
      round: u,
      isButtonTag: this.internalCloseIsButtonTag,
      absolute: !0
    }) : null, !this.checkable && this.mergedBordered ? h("div", {
      class: `${o}-tag__border`,
      style: {
        borderColor: p
      }
    }) : null);
  }
});
export {
  He as default,
  be as tagInjectionKey,
  me as tagProps
};
